import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30a116c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "what-is-new-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background" }, null, -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "inner" }
const _hoisted_5 = { class: "top" }
const _hoisted_6 = { class: "heading" }
const _hoisted_7 = { class: "points" }
const _hoisted_8 = { class: "right" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "bottom" }

import GenericButton from "@/components/buttons/GenericButton.vue";
import Icon from "@/components/icons/Icon/Icon.vue";
import { MutationTypes } from "@/store";
import { GenericButtonVariantEnum } from "@/types/button";
import { IconType } from "@/types/icons";
import { handleSetLastSeenVersion } from "@/utils/api";
import {
  getNewestAppVersionPointsArray,
  getNewestAppVersionString,
} from "@/utils/app";
import { getIconPath } from "@/utils/app/getIconPath";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'PopupWhatIsNew',
  setup(__props) {

const { t } = useI18n();
const { commit } = useStore();

const getTranslatedString = (pointKeyString: string, property: string) => {
  return t(`versions.${pointKeyString}.${property}`);
};

const pointsArray = getNewestAppVersionPointsArray();
const versionString = getNewestAppVersionString();

const handleContinue = () => {
  handleSetLastSeenVersion(versionString);
  commit(MutationTypes.HIDE_POPUP);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(t)("versions.whatIsNew")), 1),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pointsArray), (point) => {
              return (_openBlock(), _createElementBlock("div", {
                key: point.key,
                class: "point"
              }, [
                _createVNode(Icon, {
                  icon: point.key as IconType
                }, null, 8, ["icon"]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h4", _hoisted_9, _toDisplayString(getTranslatedString(point.key, "title")), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(getTranslatedString(point.key, "text")), 1)
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(GenericButton, {
            variant: _unref(GenericButtonVariantEnum).Primary,
            text: "auth.buttons.continueToApp",
            "on-click": handleContinue
          }, null, 8, ["variant"])
        ])
      ])
    ])
  ]))
}
}

})